import Segment from "./segment";

export default class Structure {
	constructor({
		name,
		values,
		segment,
		comment,
		rules,
		functions,
		aliases,
		modified
	} = {}) {
		this._name = name;
		this._values = values;
		this._segment = new Segment(segment);
		this._comment = comment || '';
		this._rules = rules || [];
		this._functions = functions || [];
		this._aliases = aliases || [];
		this._modified = modified;
	}

	getValues = () => this._values;

	getReferrer = () => this._values && this._values.referrer ? String(this._values.referrer) : null;

	getSegment = () => this._segment;

	getName = () => this._name;

	getComment = () => this._comment;

	getRules = () => this._rules;

	getSrc = () => this.getValues().logo;

	getId = () => this.getSegment().getId();

	getKey = () => this.getSegment().getKey();

	isArchived = () => this.getSegment().isArchived();

	getContacts = () => this.getSegment().getContacts();

	getMainFunction = () => this._functions[0] ? this._functions[0]["name"] : null;

	getFunctions = () => this._functions;

	getAliases = () => this._aliases;

	getModified = () => this._modified;

	getCreated = () => this.getSegment().getCreated();

	getCustomAttributes = () => Object.entries(this.getValues())
		.map(item => (
			{
				name: item[0],
				value: item[1]
			}
		))
		|| [];
} 
